module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/district-list/district-list.component.css
// module id = ./src/app/pages/Main/district-list/district-list.component.css
// module chunks = main